import {InfuraType} from "../redux/globalReducers";
import {BigNumber} from "ethers";

export function scrambleNFTBuy(infura: InfuraType, tokenId: number, amount: BigNumber) {
    return infura.scrambleNFTBuyContract.populateTransaction.buyScrambleNFT(tokenId, {
        value: amount
    });
}
